import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Layout as AntLayout } from 'antd';
import Sidebar from './Sidebar';
import Header from './Header';
import PersistentPages from '../PersistentPages';

const { Content } = AntLayout;

/**
 * Admin shell: collapsible sidebar on the left, header on top, routed
 * page content in the middle. Rendered as a layout route so nested
 * pages fill <Outlet/>.
 *
 * <PersistentPages/> lives here (always mounted, ahead of the Outlet)
 * so the dashboard/BI/restaurants pages keep their state across
 * navigation; the matching routes render `element={null}` because the
 * persistent layer renders them instead.
 */
export default function Layout() {
  const [collapsed, setCollapsed] = useState(true);

  return (
    <AntLayout className="admin-shell">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} />
      <AntLayout className="admin-workspace">
        <Header />
        <Content
          className="admin-content"
          style={{
            background: 'var(--admin-bg-content)',
          }}
        >
          <PersistentPages />
          <Outlet />
        </Content>
      </AntLayout>
    </AntLayout>
  );
}
